var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24,14.5c0,4.136-3.364,7.5-7.5,7.5H7.5c-4.136,0-7.5-3.364-7.5-7.5s3.364-7.5,7.5-7.5h4.599l-3.584-3.414c-.6-.571-.623-1.521-.051-2.121.572-.602,1.521-.624,2.121-.051l4.071,3.879c.876.875,1.344,2.004,1.344,3.207s-.468,2.333-1.319,3.182l-4.146,3.951c-.291.277-.663.414-1.035.414-.396,0-.791-.156-1.086-.465-.571-.6-.548-1.549.051-2.121l3.633-3.461h-4.599c-2.481,0-4.5,2.019-4.5,4.5s2.019,4.5,4.5,4.5h9c2.481,0,4.5-2.019,4.5-4.5,0-1.602-.863-3.096-2.251-3.899-.717-.415-.962-1.333-.547-2.049.415-.716,1.333-.962,2.049-.547,2.312,1.338,3.749,3.827,3.749,6.496Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.201ba8c996897f3c81067dd575d8db9f.svg";
export { ForwardRef as ReactComponent };